import { GLOBAL_MEETING_DATA } from "../../../../../constants/PublicVariables";
import { LogFirebase } from "../../../../../services/firestore";
import { dualStreamEnabled } from "../../../../../shared/utility";
import {
    handleVideoTrackUnsubscribedForSingleStream,
    handleVideoTrackUnsubscribedForMultiStream,
    setRemoteParticipanteAudioVideoStatus,
} from "../../../Room/roomFunction";

export const handleVideoTrackUnsubscribed = (track, remoteTrackPrublication, participant) => {
    LogFirebase("TwilioEvents", "video_trackUnsubscribed", { identity: participant.identity });
    if (GLOBAL_MEETING_DATA.ucid) {
        setRemoteParticipanteAudioVideoStatus("video", participant?.identity, false);
    }
    if (dualStreamEnabled()) {
        handleVideoTrackUnsubscribedForMultiStream(track, remoteTrackPrublication, participant);
    } else {
        handleVideoTrackUnsubscribedForSingleStream(track, remoteTrackPrublication, participant);
    }
};
